import { history } from 'instantsearch.js/es/lib/routers'
import { elementsConfig } from '../config/indices'

// Define the custom router
const router = history({
  // Delay for writing the state to the URL
  writeDelay: 300,

  // Function to generate the URL from the route state
  createURL({ qsModule, routeState, location }) {
    // Base URL (current pathname)
    const baseUrl = location.pathname

    // Define query parameters, encoding the values for URL safety
    /* @DEV: this double encoding is causing vanity issues with the URL
     * but leaving it in case we run into any issues with just using
     * stringify on the object
     *
    const queryParameters = {
      query: routeState.query && encodeURIComponent(routeState.query),
      page: routeState.page !== 1 && routeState.page,
      industries: routeState.Industries && encodeURIComponent(routeState.Industries),
      types: routeState.Types && encodeURIComponent(routeState.Types),
      technology: routeState.Technology && encodeURIComponent(routeState.Technology),
    }
     */
    const queryParameters = {
      query: routeState.query,
      page: routeState.page !== 1 && routeState.page,
      industries: routeState.Industries,
      types: routeState.Types,
      technology: routeState.Technology,
    }
    // Filter out parameters that are not defined or empty
    const validParameters = Object.entries(queryParameters).reduce((acc, [key, value]) => {
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});
    
    // Stringify the parameters into a URL query string
    const queryString = qsModule.stringify(validParameters, {
      addQueryPrefix: true,
      arrayFormat: 'repeat',
    })

    // Return the full URL
    return `${baseUrl}${queryString}`
  },

  // Function to parse the URL and return the route state
  parseURL({ qsModule, location }) {
    const {
      query = '',
      page,
      types = [],
      industries = [],
      technology = [],
    } = qsModule.parse(location.search.slice(1))

    // If the categories, types or technologies are not arrays (i.e. single values), convert them to arrays
    const allIndustries = Array.isArray(industries) ? industries : [industries].filter(Boolean)
    const allTypes = Array.isArray(types) ? types : [types].filter(Boolean)
    const allTechnologies = Array.isArray(technology) ? technology : [technology].filter(Boolean)

    // Return the route state, decoding the values for URL safety
    return {
      query: query ? decodeURIComponent(query) : '',
      page,
      Industries: allIndustries.length ? decodeURIComponent(allIndustries[0]) : '',
      Types: allTypes.length ? decodeURIComponent(allTypes[0]) : '',
      Technology: allTechnologies.length ? decodeURIComponent(allTechnologies[0]) : '',
    }
  },
})

// Define the state mapping for translating the UI state into a route state, and vice versa
const stateMapping = {
  // Function to translate the UI state into a route state
  stateToRoute(uiState) {
    const { query, page, menu } = uiState[elementsConfig.indexName]
    return {
      query,
      page,
      Industries: menu && menu['Industries'],
      Types: menu && menu['Types'],
      Technology: menu && menu['Technology'],
    }
  },

  // Function to translate a route state into a UI state
// Function to translate a route state into a UI state
  routeToState(routeState) {
    const { query, page, Industries, Types, Technology } = routeState
    return {
      [elementsConfig.indexName]: {
        query,
        page,
        // Construct the menu object dynamically using the spread operator
        // The spread operator (...) allows elements of an array or properties of an object
        // to be expanded into the containing context.
        // In the case of an object (like here), it is used to include the key-value pairs from another object.
        // Here, it is used within a conditional context to include properties
        // (Industries, Types, Technology) only if their corresponding values exist.
        menu: {
          ...(Industries && {'Industries': Industries}),
          ...(Types && {'Types': Types}),
          ...(Technology && {'Technology': Technology}),
        },
      },
    }
  },

}

// Define the overall routing configuration
const elementsRouting = {
  router,
  stateMapping,
}

// Export the routing configuration
export { elementsRouting }
